export const NEOBET_SIDEBAR_TRANSITION_MS = 180;
export const NEOBET_SIDEBAR_CONTENT_DELAY_MS = 15;

const NEOBET_SIDEBAR_EXPAND_EASING = 'cubic-bezier(0.7, -0.4, 0.4, 1.4)';
const NEOBET_SIDEBAR_COLLAPSE_EASING = 'cubic-bezier(0.3, 0, 0.2, 1)';

export const getNeobetSidebarTransitionTiming = (isCompact: boolean) =>
  `${NEOBET_SIDEBAR_TRANSITION_MS}ms ${isCompact ? NEOBET_SIDEBAR_COLLAPSE_EASING : NEOBET_SIDEBAR_EXPAND_EASING}`;

export const getNeobetSidebarResizeTransition = (isCompact: boolean) => {
  const transitionTiming = getNeobetSidebarTransitionTiming(isCompact);

  return `width ${transitionTiming}, min-width ${transitionTiming}`;
};
